import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Info, TrendingDown, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";
import { fcfa } from "@/lib/format";
import { DateField } from "@/components/DateField";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const PERIODS = [["today", "Aujourd'hui"], ["yesterday", "Hier"], ["7d", "7 jours"], ["30d", "30 jours"], ["month", "Ce mois"], ["last_month", "Mois dernier"],
  ["quarter", "Ce trimestre"], ["year", "Cette année"], ["custom", "Période personnalisée"]];
const PREV = { today: "hier", yesterday: "avant-hier", "7d": "7 jours précédents", "30d": "30 jours précédents", month: "mois dernier", last_month: "mois précédent",
  quarter: "trimestre précédent", year: "année précédente", custom: "période précédente" };

export function PeriodPicker({ value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-picker">
      <select data-testid="period-select" className="mr-input w-52" value={value.period} onChange={(e) => onChange({ ...value, period: e.target.value })}>
        {PERIODS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {value.period === "custom" && <>
        <DateField testId="period-start" className="w-full sm:w-64" placeholder="Du" value={value.start || ""} onChange={(v) => onChange({ ...value, start: v })} />
        <DateField testId="period-end" className="w-full sm:w-64" placeholder="Au" value={value.end || ""} onChange={(v) => onChange({ ...value, end: v })} />
      </>}
    </div>
  );
}

function Delta({ c, period }) {
  if (c.previous === null || c.previous === undefined) return <p className="text-xs text-mr-muted">valeur actuelle</p>;
  const pct = c.previous ? Math.round(((c.value - c.previous) / c.previous) * 100) : c.value ? 100 : 0;
  const up = pct >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  return <p className={`text-xs flex items-center gap-1 ${up ? "text-mr-success" : "text-mr-danger"}`} data-testid={`kpi-delta-${c.key}`}><Icon size={12} />{up ? "+" : ""}{pct} % vs {PREV[period]}</p>;
}

export function KpiCards({ section }) {
  const nav = useNavigate();
  const [p, setP] = useState({ period: localStorage.getItem("mr-kpi-period") || "30d" });
  const [cards, setCards] = useState(null);
  useEffect(() => {
    localStorage.setItem("mr-kpi-period", p.period);
    if (p.period === "custom" && !(p.start && p.end)) return;
    api.get("/admin/kpis", { params: { section, ...p } }).then(({ data }) => setCards(data)).catch(() => setCards([]));
  }, [section, p]);
  return (
    <div className="space-y-3 mb-8" data-testid={`kpis-${section}`}>
      <PeriodPicker value={p} onChange={setP} />
      <TooltipProvider>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {(cards || []).map((c) => (
            <button key={c.key} onClick={() => nav(c.link)} data-testid={`kpi-${section}-${c.key}`}
              className="mr-card p-4 text-left hover:border-mr-accent transition-colors">
              <div className="flex items-start justify-between gap-2"><p className="text-xs uppercase tracking-wider text-mr-muted">{c.label}</p>
                <Tooltip><TooltipTrigger asChild><span onClick={(e) => e.stopPropagation()} data-testid={`kpi-info-${c.key}`}><Info size={14} className="text-mr-muted" /></span></TooltipTrigger>
                  <TooltipContent className="max-w-xs">{c.info}</TooltipContent></Tooltip></div>
              <p className="font-display font-bold text-2xl tabular mt-1">{c.unit === "FCFA" ? fcfa(c.value) : c.value}</p>
              <Delta c={c} period={p.period} />
            </button>
          ))}
        </div>
      </TooltipProvider>
    </div>
  );
}
